import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, Field, Int32Field, StringField, BooleanField, Float32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class AudioEffectCompositeCellBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new AudioEffectCompositeCellBox({
            uuid,
            graph,
            name: "AudioEffectCompositeCellBox",
            pointerRules: {
                accepts: [Pointers.Editing, Pointers.Selection],
                mandatory: false,
                exclusive: false,
            },
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "AudioEffectCompositeCellBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({});
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitAudioEffectCompositeCellBox, this);
    }
    get tags() {
        return AudioEffectCompositeCellBox.Tags;
    }
    get composite() {
        return this.getField(1);
    }
    get audioEffects() {
        return this.getField(2);
    }
    get index() {
        return this.getField(3);
    }
    /** @deprecated */
    get label() {
        return this.getField(4);
    }
    get minimized() {
        return this.getField(5);
    }
    get gain() {
        return this.getField(40);
    }
    get mute() {
        return this.getField(41);
    }
    get solo() {
        return this.getField(42);
    }
    get pan() {
        return this.getField(43);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "composite",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.AudioEffectCompositeCell, true),
            2: Field.hook({
                parent: this,
                fieldKey: 2,
                fieldName: "audioEffects",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.AudioEffectHost],
                    mandatory: false,
                    exclusive: false,
                },
            }),
            3: Int32Field.create({
                parent: this,
                fieldKey: 3,
                fieldName: "index",
                deprecated: false,
                pointerRules: NoPointers,
            }, "index", ""),
            4: StringField.create({
                parent: this,
                fieldKey: 4,
                fieldName: "label",
                deprecated: true,
                pointerRules: NoPointers,
            }),
            5: BooleanField.create({
                parent: this,
                fieldKey: 5,
                fieldName: "minimized",
                deprecated: false,
                pointerRules: NoPointers,
            }, false),
            40: Float32Field.create({
                parent: this,
                fieldKey: 40,
                fieldName: "gain",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, "decibel", "dB", 0),
            41: BooleanField.create({
                parent: this,
                fieldKey: 41,
                fieldName: "mute",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }),
            42: BooleanField.create({
                parent: this,
                fieldKey: 42,
                fieldName: "solo",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }),
            43: Float32Field.create({
                parent: this,
                fieldKey: 43,
                fieldName: "pan",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, "bipolar", ""),
        };
    }
}
